// eslint-disable-next-line
import React, { Component } from "react";
// eslint-disable-next-line
import { Route, Switch } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import TopNav from "./components/global/Nav";
import "./App.css";
import "./styles/colors.css";
import "./styles/header.css";
import { withRouter } from 'react-router-dom';
import ThirdPartyLogin from "./components/auth/ThirdPartyLogin";
import ThirdPartySignup from "./components/auth/ThirdPartySignUp";
import ApiClient from "./api/ApiClient";
import Home from "./Home";
import Info from "./Info";
import HttpErrorModal from './components/gamification/GlobalErrorModalConnect';
import Record from "./components/player-recorder/Record";
// import ErrorBoundary from "./ErrorBoundary";
import Verify from "./components/video-verify/Verify";
import Explore from "./components/explore/Explore";

import VocabList from "./components/vocab/VocabList";
import VocabSpecificList from "./components/vocab/VocabSpecificList";
import RecordVocabList from "./components/vocab/RecordVocabList";
import CreateVocabList from "./components/vocab/CreateVocabList";

import { ErrorBoundary } from 'react-error-boundary'

import UserCam from "./components/player-recorder/Webcam";
import User from "./components/profile/User";

import SeedFactory from "./components/player-recorder/SeedFactory";

// FB + TOS 
import FBTOS from "./components/tos/FBTOS";
import FBPrivacy from "./components/tos/FBPrivacy";

import Profile from "./components/profile/Profile";
import GoogleAuthIntermediate from "./components/auth/GoogleAuthIntermediate";
import UserProfile from "./components/profile/UserProfile";
import Footer from "./components/global/Footer";
import defaultProfileImg from './resources/profile.svg';
import AuthService from './services/auth/AuthService';

import Wikipedia from './components/wiki/Wikipedia';
import RecordNewModelVideo from './components/player-recorder/RecordNewModelVideo';
import cookie from 'react-cookies';
import DisappearNotification from "./modals/disappearNotification";
import { createBrowserHistory } from "history";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { browserCompatibilityCheck, updateUserLocation } from "./utils/userAgent";
import { updateScore, populateStore, requestFailedModal } from './actions';
import { connect } from 'react-redux';
import AdminDashboard from "./components/admin-dashboard/AdminDashboard";
import StatsDashboard from "./components/admin-dashboard/StatsDashboard";
import APIDashboard from "./components/admin-dashboard/APIDashboard";
import { debounce } from "./utils/utilMethods";
import { Dropdown } from 'semantic-ui-react';
import SelectSearch from 'react-select-search';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';

const browserHistory = createBrowserHistory({ basename: '' });
var reactPlugin = new ReactPlugin();
var appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: "1tlqp5trhd0uocfckt35wdiypcg5jm3v5zdvwowj",
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory }
        }
    }
});
appInsights.loadAppInsights();

class AppContainer extends Component {

    constructor() {
        super();
        this.apiClient = new ApiClient();
        this.state = {
            locationString: "",

            showPageHeader: false,
            sOptions: [],
            homeSubnav: "",
            mainTitle: "",
            description: "",
            searchText: "",
            searchPlaceholder: "",
            isEUGeo: true,
            isOpen: false,
            showInvisibleModal: false,
            isTokenVerificationComplete: false,
            userToken: '',
            isUserLoggedIn: false,
            loggedInAccountType: '',
            isCompatible: "",
            browser: "",
            isMobile: "",
            isTablet: "",
            loggedInUser: '',
            loggedInUserName: '',
            loggedInUserId: '',
            loggedInThirdPartyUserId: '',
            loggedInUserEmail: '',
            loggedInUserParticipatingGroups: null,
            isGroupSignIn: false,
            signedInGroup: null,
            dropdownSelectOptions: [],
            mappedSelections: [
                { key: 'af', value: 'af', text: 'Loading' }
            ],
            video: null,
            studyCode: '',
            profileImg: '',
            selectedEmail: '',
            selectedUserId: '',
            defaultProfileImg: 'profile.svg',
            userCookieConsent: false,
            searchVisible: false,
            totalUserRecordings: 0,
            verifyStudyCodeExists: false,
            loggedInUserLevel: {
                name: 'public',
                profile: false,
                otherProfile: false,
                verify: false,
                record: false,
                socialMedialLinks: false
            },
            userAccessLevels: [
                {
                    name: 'public',
                    profile: false,
                    otherProfile: false,
                    verify: false,
                    record: false,
                    socialMedialLinks: false
                },
                {
                    name: 'Rookie',
                    profile: false,
                    otherProfile: true,
                    verify: false,
                    record: true,
                    socialMedialLinks: false
                },
                {
                    name: 'Pro',
                    profile: true,
                    otherProfile: true,
                    verify: false,
                    record: true,
                    socialMedialLinks: true
                },
                {
                    name: 'MVP',
                    profile: true,
                    otherProfile: true,
                    verify: true,
                    record: true,
                    socialMedialLinks: true
                },
            ]
        };


        // require('dotenv').config();
        //this.updateVideoState = this.updateVideoState.bind(this);
        this.updateSelectedUserDetails = this.updateSelectedUserDetails.bind(this);
    }

    // options = [
    //     { name: 'Dictionary', value: 'sv' },
    //     { name: 'Wiki', value: 'en' },
    //     {
    //         type: 'wiki',
    //         name: 'Wiki',
    //         items: [
    //             { name: 'Wiki Article', value: 'es' },
    //         ]
    //     },
    // ];

    options = [
        {
            type: 'group',
            name: 'Dictionary',
            items: [
                { name: 'About', value: 'es' },
            ]
        },
        {
            type: 'group',
            name: 'Wiki',
            items: [
                { name: 'Abacus', value: 'es' },
            ]
        },
    ];


    componentWillMount() {


        /*
        *
        * Handle no show for EU Region
        * 
        */
        function onConsentChanged(categoryPreferences) {

        }

        /* eslint-disable */
        WcpConsent.init("en-US", "cookie-banner", async (err, _siteConsent) => {
            var isEU = _siteConsent.isConsentRequired;
            await this.setState({ isEUGeo: isEU });
            if (!isEU) {
                const { isCompatible, browser, isMobile, isTablet } = browserCompatibilityCheck();
                const rLocation = window.location.pathname;
                await this.setState({ isCompatible, browser, isMobile, isTablet });

                this.apiClient.postJSON(this, "/logDeviceAccess", {
                    browser, isMobile, isTablet, isCompatible, route: rLocation
                }).then((res) => {

                })
            }
            else {

            }
        }, onConsentChanged, window.WcpConsent.themes.light);

        function setNonEssentialCookies(categoryPreferences) {
            if (categoryPreferences.Analytics) { /* ... */ }
            if (categoryPreferences.Advertising) { /* ... */ }
            if (categoryPreferences.SocialMedia) { /* ... */ }
        }

        function manageConsent() {
            if (siteConsent.isConsentRequired) {
                siteConsent.manageConsent();
            }
        }

        WcpConsent.onInitCallback(setNonEssentialCookies);

        // window.WcpConsent.init("en-US", "cookie-banner");
    }

    checkForFlaggedUser = async (user) => {
        if (user.avertViolationsCount >= 3 || user.cvsViolationsCount >= 3) {
            await this.setState({ blockedAccount: true })
        }
    }

    setDropdownState = (data) => {
        this.setState({ dropdownSelectOptions: data, searchVisible: true })
    }

    // onLoggedInChanged = (isLoggedIn, loggedInUser, loggedInUserEmail, loggedInUserId, loggedInThirdPartyUserId, loggedInUserName, loggedInUserLevel) => {

    //     if (loggedInUserId || loggedInThirdPartyUserId) {
    //         updateUserLocation(this.apiClient, loggedInUserName)
    //     }
    //     var userAccess = {
    //         name: 'public',
    //         profile: false,
    //         otherProfile: false,
    //         verify: false,
    //         record: false,
    //         socialMedialLinks: false
    //     };
    //     if (isLoggedIn) {
    //         userAccess = this.state.userAccessLevels.filter(x => x.name === loggedInUserLevel)[0];
    //     }


    //     this.setState({ showInvisibleModal: true });
    //     setTimeout(() => {
    //         this.setState({ showInvisibleModal: false });
    //     }, 4000)


    //     this.setState({
    //         isUserLoggedIn: isLoggedIn,
    //         loggedInUser: loggedInUser,
    //         loggedInUserId: loggedInUserId,
    //         loggedInUserName: loggedInUserName,
    //         loggedInThirdPartyUserId: loggedInThirdPartyUserId,
    //         loggedInUserLevel: userAccess,
    //         loggedInUserEmail: loggedInUserEmail
    //     });

    // }

    loadUser = () => {
        this.apiClient.getJSON(this,'/getUser', '').then(async (res) => {
            if (res && res.status) {
                if (res.data) {
                    await this.checkForFlaggedUser(res.data);
                    this.props.dispatch(populateStore(res.data));
                    this.getRecordingsCount(res.data._id);
                    var userAccess = this.state.userAccessLevels.filter(x => x.name === res.data.level)[0];
                    this.setState({
                        loggedInUserLevel: userAccess, isUserLoggedIn: true, loggedInUserName: res.data.userName, loggedInUserEmail: res.data.email,
                        loggedInUserId: res.data._id
                    });
                    //this.getGroups(res.user._id);
                }
            }
            else if (res && res.httpServerError) {
                // throw "Something Went Wrong"
            }
        });
    }


    updateUserAccountType = (type) => {
        this.setState({ loggedInAccountType: type });
    }
    updateUserToken = (token) => {
        this.setState({ userToken: token });
    }
    updateUserEmail = (email) => {
        this.setState({ loggedInUser: email });
    }
    updateUserName = (name) => {
        this.setState({ loggedInUserName: name });
    }

    // Logs Users Out of all SSO
    logout = () => {
        localStorage.removeItem("jwtToken");
        window.location.href = process.env.PUBLIC_URL + "/tpLogin";
    }

    onProfileImgChanged = (imgUrl) => {
        if (imgUrl === "") {
            this.setState({ profileImg: defaultProfileImg })
        } else {
            this.setState({
                profileImg: imgUrl
            });
        }
    }

    updateLoggedInUserName = (userName) => {
        this.setState({
            loggedInUserName: userName
        });
    }
    updateLoggedInThirdPartyUserId = (userid) => {
        this.setState({
            loggedInThirdPartyUserId: userid
        });
    }

    updateCurrentUserLevel = (level) => {
        var uLevel = this.state.userAccessLevels.filter(x => x.name === level)[0];
        //this.setState({loggedInUserLevel: uLevel});
        this.state.loggedInUserLevel = uLevel;
    }

    updateSelectedUserDetails = (email, userId) => {
        this.setState({ selectedEmail: email, selectedUserId: userId });
    }

    setPageHeaderState = (isVisible, searchPlaceholder, homeSubnav, mainTitle, description) => {
        if (!isVisible) {
            this.setState({ showPageHeader: false })
        }
        else {
            this.setState({ showPageHeader: true, homeSubnav, mainTitle, description, searchPlaceholder })
        }
    }

    setTopLevelState = (path) => {
        switch (path) {
            case "/explore":
                this.setPageHeaderState(true, "Search dictionary for a sign", "Dictionary / Explore", "ASL Dictionary", "Find, sort, and view video submissions.");
                break;
            case "/verify":
                this.setPageHeaderState(true, "Search for a sign to verify", "Dictionary / Verify", "Verify videos", "Judge whether the submitted sign adequately demonstrates the model sign.");
                break;
            case "/record":
                this.setPageHeaderState(true, "Search for sign to record", "Dictionary / Record", "Record a sign", "View the sign below. When you’re ready, please click “Record” to record yourself executing the sign.");
                break;
            case "/wikipedia":
                this.setPageHeaderState(true, "Search for content to view or record", "Contribute / Wikipedia", "ASL Wikipedia", "Find and record Wikipedia articles powered by the ASL community.");
                break;
            default:
                this.setPageHeaderState(false);
                break;
        }
    }

    handleStayInTouchChange = (inpt) => {
        const email = inpt.target.value;
        this.setState({ stayInTouchEmail: email })
    }

    stayInTouchSignup = () => {
        const email = this.state.stayInTouchEmail;
        this.apiClient.postJSON(this, "/stayInTouch/signup", {
            email
        }).then((res) => {
            if (res && res.status) {
                this.setState({ showStayInTouchModal: true });
                setTimeout(() => {
                    this.setState({ showStayInTouchModal: false });
                }, 10000);
            }
            else if (res && res.httpServerError) {
                // throw "Something Went Wrong With User Action";
            }
        })
    }


    componentWillUnmount() {
        // stream.getTracks().forEach(function(track) {
        //     track.stop();
        //   });
        this.unlisten();
    }


    async componentDidMount() {
        // Detect router changes to reflect top level data
        this.unlisten = this.props.history.listen(async (location, action) => {
            let path = location.pathname;
            if (location.pathname[location.pathname.length - 1] === "/") {
                path = path.slice(0, -1)
            }
            this.setTopLevelState(path);
            const { isCompatible, browser, isMobile, isTablet } = browserCompatibilityCheck();
            await this.setState({ isCompatible, browser, isMobile, isTablet })

            this.apiClient.postJSON(this, "/logDeviceAccess", {
                browser, isMobile, isTablet, isCompatible, route: path
            }).then((res) => {

            })
        });
        // Set inititial load data
        let path = window.location.pathname;
        if (window.location.pathname[location.pathname.length - 1] === "/") {
            path = path.slice(0, -1)
        }
        this.setTopLevelState(path);
        this.loadUser()

    }


    setUserCookieConsent = (cookieConsent) => {
        this.setState({ userCookieConsent: cookieConsent });
    }

    updateMSUserAuthStatus = () => {
        return new AuthService().isAuthenticatedUsingMS();
    }

    // Facebook Method
    updateUserAuthStatus = () => {
        return new Promise((resolve, reject) => {
            new AuthService().isAuthenticated(this.apiClient).then((res) => {
                if (res) {
                    resolve(res);
                } else {
                    reject('User not logged in');
                }
            });
        });
    }

    getRecordingsCount = (loggedInUserId) => {
        var current = this;
        if (loggedInUserId) {
            this.apiClient.getJSON(this,'/getRecordingsCount')
                .then((res) => {
                    if (res && res.status) {
                        current.setState({ totalUserRecordings: res.data.totalRecordedVideos });
                    }
                    else if (res && res.httpServerError) {
                        // throw "Something Went Wrong"
                    }
                });
        }
    }

    // Debounce input
    debounceInitTime;
    debounceSearchText = debounce();

    performQuery = (query) => {
        let qq = query.toUpperCase();
        this.setState({ searchText: qq });
    }

    handleInputChange = (selection) => {
        selection = selection.toUpperCase();
        this.performQuery(selection)
    }

    getOptions = async (query) => {
        try {
            let loadOptions = null;
            const options = await new Promise((resolve, reject) => {
                loadOptions = setInterval(async () => {
                    try {
                        if (this.state.dropdownSelectOptions.length > 0) {
                            var self = this;
                            const filtered = self.state.dropdownSelectOptions.filter((select) => {
                                const result = (select.name.toUpperCase()).includes(query.toUpperCase());
                                return result;
                            });
                            resolve(filtered)
                        }
                    }
                    catch (e) {
                        resolve([])
                    }
                }, 200)
            });
            clearInterval(loadOptions);
            this.setState({ sOptions: options })
            return options;
        }
        catch (e) {
            return []
        }
    }

    // options = [
    //     {name: 'Swedish', value: 'sv'},
    //     {name: 'English', value: 'en'},
    //     {
    //         type: 'group',
    //         name: 'Group name',
    //         items: [
    //             {name: 'Spanish', value: 'es'},
    //         ]
    //     },
    // ];

    clearSearchResults = async () => {
        await this.setState({ searchText: "" });
        // setTimeout(() => {
        //     this.performQuery("");
        // },500)
    }


    customFilter = (option, searchText) => {
        if (
            option.data.label.includes(searchText.toUpperCase())
        ) {
            return true;
        } else {
            return false;
        }

    }

    onAddModelVideo = () => {
        if (this.props) {
            this.props.history.push("/recordSeedVideo");
        }
    }


    ErrorFallback = ({ error, resetErrorBoundary }) => {

        return (
            <div style={{
                margin: "0 auto",
                fontSize: "18px",
                fontWeight: "bold",
                height: "400px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column"
            }}><div style={{ marginBottom: "15px" }}>Something went wrong. Please refresh your page or try another link.</div>
                <div style={{ marginBottom: "15px" }}><button onClick={() => window.location.reload()} className="record-btn clicker">Refresh Page</button></div>
                <div style={{ marginBottom: "15px" }}><button onClick={() => window.location.href = "/"} className="record-btn clicker">ASL Home</button></div>
                <div>If the the problem persists, please contact us.</div>
            </div>
        )
    }



    render() {

        if (this.state.blockedAccount) {
            return (
                <Container>
                    We apologize, but your account has been locked due to inappropriate content detected in three or more videos. If you believe this to be a mistake, please contact us at aslgames@microsoft.com
                </Container>
            )
        }
        else if (this.state.isEUGeo === true) {
            return (
                <Container>
                    We apologize, but our site uses cookies which are restricted in your region.
                </Container>
            )
        }
        else if (this.state.isEUGeo === undefined) {
            return (
                null
            )
        }

        if (!this.state.isCompatible) {
            if (this.state.isMobile) {
                return (
                    <Container>
                        We apologize, but we do not currently support mobile devices, please give us a try on a PC
                    </Container>
                )
            }
            else {
                return (
                    <Container style={{ textAlign: "center", marginTop: "100px" }}>
                        <div style={{ fontSize: "20px", marginBottom: "20px" }}> We apologize, but we do not currently support {this.state.browser}, please give us a try on Chrome or Edge.</div>
                        <div style={{ fontSize: "50px" }}>&#x1F633;</div>
                        <div>We're working on support for your favorite {this.state.browser} so stay tuned as we resolve our backward compatibility issues</div>
                    </Container>
                )
            }
        }

        // authmod
        // newVideo: this.updateVideoState,
        //const video = {video: this.state.video, userLevel:this.state.userAccessLevel};
        const newVideo = {
            video: this.state.video, studyCode: this.state.studyCode, updateUserLevel: this.updateCurrentUserLevel,
            userName: this.state.loggedInUser, userid: this.state.loggedInUserId, userLevel: this.state.userAccessLevel
        };
        let self = this;
        
        //const showFooter = this.state.isUserLoggedIn ? {}: {display:'none'};
        return (
            <ErrorBoundary
                FallbackComponent={this.ErrorFallback}
                onReset={() => {
                    // reset the state of your app so the error doesn't happen again
                }}
            >
                <React.Fragment>
             
                    <div className="main-container">
                    <HttpErrorModal />
                        <header>

                        </header>
                        {/* <DisappearNotification background="#fff" isTransparent={true} symbol="check-mark" text="Your account has been restored! If this wasn't your intention, please feel free to delete it again, and sign up with a different one." showInvisibleModal={this.state.showInvisibleModal}></DisappearNotification> */}
                        <div className="nav">
                            <div className="nav-wrapper">
                                <TopNav logOut={this.logout} groupSignIn={(groupId, isOwnedGroup) => this.groupSignIn(groupId, isOwnedGroup)} signedInGroup={this.state.signedInGroup} groups={this.state.loggedInUserParticipatingGroups} profileImg={this.state.profileImg} isLoggedIn={this.state.isUserLoggedIn} userId={this.state.loggedInUserId}
                                />
                            </div>
                        </div>
                        
                        {location.pathname == "/" && <div className="back-div">
                            <div className="back-div-inner">
                                <div className="cntr" style={{ marginBottom: "50px", marginTop: "-70px" }}>
                                    <div className="homepage-big-title cntr"><h1 h3 role="heading">Welcome to the ASL Data Community</h1></div>
                                    <div className="homepage-subtitle cntr">Enabling volunteers to contribute American Sign Language (ASL) videos to advance sign language recognition, translation, and generation, while fostering ASL community online.</div>
                                </div>
                                <div className="homepage-btns-container">
                                    <div className="homepage-btns-col">
                                        <div className="cntr">
                                            <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g filter="url(#filter0_dZ)">
                                                    <circle cx="70" cy="60" r="50" fill="url(#paint0_linear)" />
                                                    <rect x="46" y="52" width="40" height="32" rx="2" stroke="white" stroke-width="2" />
                                                    <line x1="45" y1="61.04" x2="86.28" y2="61.04" stroke="white" stroke-width="2" />
                                                    <path d="M72 72.5L63 77.2631L63 67.7369L72 72.5Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
                                                    <rect x="74.6797" y="55.2803" width="3" height="3" rx="1.5" fill="white" />
                                                    <rect x="79.5195" y="55.2803" width="3" height="3" rx="1.5" fill="white" />
                                                    <path d="M86 68.6H91.7197C92.8243 68.6 93.7197 67.7046 93.7197 66.6V37C93.7197 35.8954 92.8243 35 91.7197 35H55.7197C54.6152 35 53.7197 35.8954 53.7197 37V52" stroke="white" stroke-width="2" />
                                                    <line x1="52.7197" y1="44.6396" x2="93.9997" y2="44.6396" stroke="white" stroke-width="2" />
                                                    <rect x="82.4004" y="37.8799" width="3" height="3" rx="1.5" fill="white" />
                                                    <rect x="87.2402" y="37.8799" width="3" height="3" rx="1.5" fill="white" />
                                                </g>
                                                <defs>
                                                    <filter id="filter0_dZ" x="0" y="0" width="140" height="140" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                                                        <feOffset dy="10" />
                                                        <feGaussianBlur stdDeviation="10" />
                                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                                                    </filter>
                                                    <linearGradient id="paint0_linearX" x1="70" y1="110" x2="103.066" y2="22.4945" gradientUnits="userSpaceOnUse">
                                                        <stop offset="0.145833" stop-color="#127BC2" />
                                                        <stop offset="1" stop-color="#00BEC1" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>

                                        </div>
                                        <div className="cntr homepage-btn-description">
                                            Watch Amazing Videos of Signers 
                                        </div>
                                        <div className="cntr">
                                            <button className="homepage-btn" onClick={() => this.props.history.push("/explore")} >Explore Videos</button>
                                        </div>
                                    </div>
                                    {/* <div className="homepage-btns-col">
                                    <div className="cntr">
                                        <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_dY)">
                                                <circle cx="70" cy="60" r="50" fill="url(#paint0_linear)" />
                                                <rect x="46" y="52" width="40" height="32" rx="2" stroke="white" stroke-width="2" />
                                                <line x1="45" y1="61.04" x2="86.28" y2="61.04" stroke="white" stroke-width="2" />
                                                <path d="M72 72.5L63 77.2631L63 67.7369L72 72.5Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
                                                <rect x="74.6797" y="55.2803" width="3" height="3" rx="1.5" fill="white" />
                                                <rect x="79.5195" y="55.2803" width="3" height="3" rx="1.5" fill="white" />
                                                <path d="M86 68.6H91.7197C92.8243 68.6 93.7197 67.7046 93.7197 66.6V37C93.7197 35.8954 92.8243 35 91.7197 35H55.7197C54.6152 35 53.7197 35.8954 53.7197 37V52" stroke="white" stroke-width="2" />
                                                <line x1="52.7197" y1="44.6396" x2="93.9997" y2="44.6396" stroke="white" stroke-width="2" />
                                                <rect x="82.4004" y="37.8799" width="3" height="3" rx="1.5" fill="white" />
                                                <rect x="87.2402" y="37.8799" width="3" height="3" rx="1.5" fill="white" />
                                            </g>
                                            <defs>
                                                <filter id="filter0_dY" x="0" y="0" width="140" height="140" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                                                    <feOffset dy="10" />
                                                    <feGaussianBlur stdDeviation="10" />
                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                                                </filter>
                                                <linearGradient id="paint0_linear" x1="70" y1="110" x2="103.066" y2="22.4945" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0.145833" stop-color="#127BC2" />
                                                    <stop offset="1" stop-color="#00BEC1" />
                                                </linearGradient>
                                            </defs>
                                        </svg>

                                    </div>
                                    <div className="cntr homepage-btn-description">
                                        Validate signs contributed by others
                                    </div>
                                    <div className="cntr">
                                        <button className="homepage-btn" onClick={() => this.props.history.push("/verify")} >Verify Videos</button>
                                    </div>
                                </div> */}
                                    {/* <div className="homepage-btns-col">
                                    <div className="cntr">
                                        <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_dX)">
                                                <circle cx="70" cy="60" r="50" fill="url(#paint0_linear)" />
                                                <path d="M79.1642 72.3953L79.1626 72.3969C78.4351 73.1244 78.4449 74.3211 79.1556 75.0911L79.1554 75.0913L79.1636 75.0993L88.188 84.0198C88.1883 84.0201 88.1885 84.0204 88.1888 84.0206C88.333 84.1645 88.4991 84.25 88.7306 84.25C88.8973 84.25 89.1179 84.1738 89.2717 84.0204C89.2719 84.0202 89.2721 84.02 89.2722 84.0198L93.602 79.7431L93.6031 79.742C93.9093 79.4358 93.9094 78.9645 93.6034 78.6582C93.6033 78.6581 93.6032 78.6579 93.6031 78.6578L84.6815 69.6333L84.6805 69.6323C84.3155 69.2673 83.819 69.0893 83.3298 69.0893C82.8409 69.0893 82.3447 69.2671 81.9798 69.6317C81.9796 69.6319 81.9793 69.6321 81.9791 69.6323L79.1642 72.3953ZM83.0617 70.6652L83.0633 70.6635C83.1096 70.6172 83.1965 70.5808 83.3043 70.5808C83.3946 70.5808 83.4875 70.6059 83.5969 70.715C83.597 70.7152 83.5972 70.7153 83.5973 70.7155L91.9756 79.1456L88.7308 82.3444L80.2457 73.9622C80.2455 73.9619 80.2453 73.9617 80.2451 73.9615C80.1574 73.8735 80.1233 73.7793 80.1233 73.6957C80.1233 73.612 80.1574 73.5178 80.245 73.4299C80.2452 73.4297 80.2455 73.4294 80.2457 73.4292L83.0617 70.6652ZM65.7741 35.75C54.7317 35.75 45.75 44.7317 45.75 55.7741C45.75 66.8165 54.7317 75.7982 65.7741 75.7982C76.8166 75.7982 85.7972 66.8165 85.7972 55.7741C85.7972 44.7317 76.8166 35.75 65.7741 35.75ZM65.7741 37.2935C75.9665 37.2935 84.2537 45.5817 84.2537 55.7741C84.2537 60.474 82.4889 64.7653 79.5893 68.0295V49.8261C79.5893 48.4839 78.4812 47.4372 77.1994 47.4372H54.3478C53.0058 47.4372 51.9589 48.5442 51.9589 49.8261V68.0295C49.0592 64.7652 47.2935 60.474 47.2935 55.7741C47.2935 45.5818 55.5818 37.2935 65.7741 37.2935ZM54.3478 48.9806H77.1994C77.68 48.9806 78.0459 49.3828 78.0459 49.8261V69.5792C74.7796 72.4859 70.4809 74.2548 65.7741 74.2548C61.0678 74.2548 56.7685 72.4863 53.5024 69.5802V49.8261C53.5024 49.3457 53.9042 48.9806 54.3478 48.9806ZM56.7476 51.4541C56.5343 51.4541 56.3371 51.5263 56.1926 51.6708C56.0481 51.8153 55.9759 52.0126 55.9759 52.2259C55.9759 52.4392 56.0481 52.6364 56.1926 52.7809C56.3371 52.9254 56.5343 52.9976 56.7476 52.9976H74.7996C75.0129 52.9976 75.2101 52.9254 75.3546 52.7809C75.4991 52.6364 75.5713 52.4392 75.5713 52.2259C75.5713 52.0126 75.4991 51.8153 75.3546 51.6708C75.2101 51.5263 75.0129 51.4541 74.7996 51.4541H56.7476ZM56.7476 55.4721C56.5343 55.4721 56.3371 55.5443 56.1926 55.6888C56.0481 55.8333 55.9759 56.0306 55.9759 56.2439C55.9759 56.4572 56.0481 56.6544 56.1926 56.7989C56.3371 56.9434 56.5343 57.0156 56.7476 57.0156H74.7996C75.0129 57.0156 75.2101 56.9434 75.3546 56.7989C75.4991 56.6544 75.5713 56.4572 75.5713 56.2439C75.5713 56.0306 75.4991 55.8333 75.3546 55.6888C75.2101 55.5443 75.0129 55.4721 74.7996 55.4721H56.7476ZM56.7476 59.4891C56.5343 59.4891 56.3371 59.5613 56.1926 59.7058C56.0481 59.8503 55.9759 60.0475 55.9759 60.2609C55.9759 60.4742 56.0481 60.6714 56.1926 60.8159C56.3371 60.9604 56.5343 61.0326 56.7476 61.0326H74.7996C75.0129 61.0326 75.2101 60.9604 75.3546 60.8159C75.4991 60.6714 75.5713 60.4742 75.5713 60.2609C75.5713 60.0475 75.4991 59.8503 75.3546 59.7058C75.2101 59.5613 75.0129 59.4891 74.7996 59.4891H56.7476ZM56.7476 63.5061C56.5343 63.5061 56.3371 63.5783 56.1926 63.7228C56.0481 63.8673 55.9759 64.0645 55.9759 64.2779C55.9759 64.4912 56.0481 64.6884 56.1926 64.8329C56.3371 64.9774 56.5343 65.0496 56.7476 65.0496H74.7996C75.0129 65.0496 75.2101 64.9774 75.3546 64.8329C75.4991 64.6884 75.5713 64.4912 75.5713 64.2779C75.5713 64.0645 75.4991 63.8673 75.3546 63.7228C75.2101 63.5783 75.0129 63.5061 74.7996 63.5061H56.7476Z" fill="white" stroke="white" stroke-width="0.5" />
                                            </g>
                                            <defs>
                                                <filter id="filter0_dX" x="0" y="0" width="140" height="140" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                                                    <feOffset dy="10" />
                                                    <feGaussianBlur stdDeviation="10" />
                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                                                </filter>
                                                <linearGradient id="paint0_linearY" x1="91.5278" y1="14.1667" x2="87.3561" y2="110.636" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FF8150" />
                                                    <stop offset="1" stop-color="#D73C00" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div className="cntr homepage-btn-description">
                                        Explore the ASL communal Dictionary
                                    </div>
                                    <div className="cntr">
                                        <button className="homepage-btn" onClick={() => this.props.history.push("/explore")} >Explore Dictionary</button>
                                    </div>
                                </div> */}
                                </div>
                            </div>
                        </div>
                        }

                        <div className="inner-container">
                            {this.state.showPageHeader && (<div className="page-header">
                                <div className="header-col-1">
                                    {/* <div className="sub-directory">
                            {this.state.homeSubnav}
                        </div> */}
                                    <div className="main-title">
                                        <h3 role="heading">{this.state.mainTitle}</h3>
                                    </div>
                                </div>
                                <div className="header-col-2">
                                    <div className="description">
                                        {/* {this.state.description} */}
                                    </div>
                                </div>
                                <div className="header-col-3">
                                    {/* {this.state.loggedInUserLevel.verify &&
                                        <div className="search-and-seed">
                         
                                            <button className="seed-btn record-btn" type="button" onClick={() => this.onAddModelVideo()} aria-label="Add Model Video">
                                                Add New Seed Video
                                            </button>
                                        </div>
                                    } */}
                                </div>
                                <div className="header-col-4"></div>
                                <div className="header-col-5">
                                    <div className="header-search">


                                        <SelectSearch
                                            disabled={!this.state.searchVisible}
                                            placeholder={this.state.searchPlaceholder}
                                            // autocomplete="off"
                                            options={this.state.sOptions}
                                            // closeOnSelect={true}
                                            getOptions={this.getOptions}
                                            search
                                            onChange={this.handleInputChange}
                                            value={this.state.searchText}
                                        >


                                        </SelectSearch>
                                        <svg className="search-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 11.7101 16.9276 13.2866 15.964 14.5483L20.7071 19.2929C21.0976 19.6834 21.0976 20.3166 20.7071 20.7071C20.3466 21.0676 19.7794 21.0953 19.3871 20.7903L19.2929 20.7071L14.5483 15.964C13.2866 16.9276 11.7101 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5ZM10 4.5C6.96243 4.5 4.5 6.96243 4.5 10C4.5 13.0376 6.96243 15.5 10 15.5C13.0376 15.5 15.5 13.0376 15.5 10C15.5 6.96243 13.0376 4.5 10 4.5Z" fill="#6E6E6E" />
                                        </svg>
                                        {this.state.searchText && <HighlightOffRoundedIcon onClick={this.clearSearchResults} className="clear-search-btn" />}

                                    </div>
                                </div>
                            </div>)
                            }
                            <Switch>
                                <Route exact path="/" render={props => <Home loadUser={this.loadUser} signedInGroupId={this.state.signedInGroup ? this.state.signedInGroup._id : undefined} setCookieConsent={(cookieConsent) => this.setUserCookieConsent(cookieConsent)} isLoggedIn={this.state.isUserLoggedIn} userLevel={this.state.loggedInUserLevel} userName={this.state.loggedInUserName} userId={this.state.loggedInUserId}  {...props} />}>
                                </Route>

                                <Route path="/rerouteGoogleAuth" render={props => <GoogleAuthIntermediate {...props} apiClient={this.apiClient} />}>
                                </Route>
                                <Route path="/info" render={props => <Info setCookieConsent={(cookieConsent) => this.setUserCookieConsent(cookieConsent)} isLoggedIn={this.state.isUserLoggedIn} userLevel={this.state.loggedInUserLevel}
                                    {...props} />}>
                                </Route>

                                {/* <Route path="/seedFactory" render={props => <SeedFactory setDropdownState={this.setDropdownState}
                                searchText={this.state.searchText}
                                totalRecordings={this.state.totalUserRecordings}
                                setCookieConsent={(cookieConsent) => this.setUserCookieConsent(cookieConsent)}
                                isLoggedIn={this.state.isUserLoggedIn} video={this.state.video} studyCode={this.state.studyCode}
                                updateCount={this.getRecordingsCount} userName={this.state.loggedInUser} userLevel={this.state.loggedInUserLevel}
                                loggedInUser={this.state.loggedInUserId}  {...props} />}>
                            </Route> */}

                                {/* <Route path="/vocab-record" render={props => <RecordVocabList setDropdownState={this.setDropdownState}
                                searchText={this.state.searchText}
                                totalRecordings={this.state.totalUserRecordings}
                                setCookieConsent={(cookieConsent) => this.setUserCookieConsent(cookieConsent)}
                                isLoggedIn={this.state.isUserLoggedIn} video={this.state.video} studyCode={this.state.studyCode}
                                updateCount={this.getRecordingsCount} userName={this.state.loggedInUser} userLevel={this.state.loggedInUserLevel}
                                loggedInUser={this.state.loggedInUserId}  {...props} />}>
                            </Route> */}

                                {/* <Route path="/record" render={props => <Record setDropdownState={this.setDropdownState}
                                    searchText={this.state.searchText}
                                    totalRecordings={this.state.totalUserRecordings}
                                    setCookieConsent={(cookieConsent) => this.setUserCookieConsent(cookieConsent)}
                                    isLoggedIn={this.state.isUserLoggedIn} video={this.state.video} studyCode={this.state.studyCode}
                                    updateCount={this.getRecordingsCount} userName={this.state.loggedInUser} userLevel={this.state.loggedInUserLevel}
                                    loggedInUser={this.state.loggedInUserId}  {...props} />}>
                                </Route> */}

                                {/* <Route path="/record/:video" render={props => <Record totalRecordings={this.state.totalUserRecordings} isLoggedIn={this.state.isUserLoggedIn} video={this.state.video} studyCode={this.state.studyCode} userLevel={this.state.loggedInUserLevel}
                                    {...props} />}>
                                </Route> */}

                                {/* <Route path="/verify" render={props => <Verify setDropdownState={this.setDropdownState} searchText={this.state.searchText} signedInGroupId={this.state.signedInGroup ? this.state.signedInGroup._id : undefined} setCookieConsent={(cookieConsent) => this.setUserCookieConsent(cookieConsent)} isLoggedIn={this.state.isUserLoggedIn} verifyCodeExists={this.state.verifyStudyCodeExists} userId={this.state.loggedInUserId} userLevel={this.state.loggedInUserLevel}  {...props} />}>
                            </Route>

                            <Route path="/create-vocab-list" render={props => <CreateVocabList setDropdownState={this.setDropdownState} searchText={this.state.searchText} signedInGroupId={this.state.signedInGroup ? this.state.signedInGroup._id : undefined} setCookieConsent={(cookieConsent) => this.setUserCookieConsent(cookieConsent)} userId={this.state.loggedInUserId} isLoggedIn={this.state.isUserLoggedIn} userLevel={this.state.loggedInUserLevel} loggedInUser={this.state.loggedInUser} updateSelectedUser={(email, userId) => this.updateSelectedUserDetails(email, userId)}  {...props} />}>
                            </Route>

                            <Route path="/vocab" render={props => <VocabList setDropdownState={this.setDropdownState} searchText={this.state.searchText} signedInGroupId={this.state.signedInGroup ? this.state.signedInGroup._id : undefined} setCookieConsent={(cookieConsent) => this.setUserCookieConsent(cookieConsent)} userId={this.state.loggedInUserId} isLoggedIn={this.state.isUserLoggedIn} userLevel={this.state.loggedInUserLevel} loggedInUser={this.state.loggedInUser} updateSelectedUser={(email, userId) => this.updateSelectedUserDetails(email, userId)}  {...props} />}>
                            </Route>

                            <Route path="/vocab-specific-list" render={props => <VocabSpecificList setDropdownState={this.setDropdownState} searchText={this.state.searchText} signedInGroupId={this.state.signedInGroup ? this.state.signedInGroup._id : undefined} setCookieConsent={(cookieConsent) => this.setUserCookieConsent(cookieConsent)} userId={this.state.loggedInUserId} isLoggedIn={this.state.isUserLoggedIn} userLevel={this.state.loggedInUserLevel} loggedInUser={this.state.loggedInUser} updateSelectedUser={(email, userId) => this.updateSelectedUserDetails(email, userId)}  {...props} />}>
                            </Route>
                            */}
                            <Route path="/explore" render={props => <Explore setDropdownState={this.setDropdownState} searchText={this.state.searchText} signedInGroupId={this.state.signedInGroup ? this.state.signedInGroup._id : undefined} setCookieConsent={(cookieConsent) => this.setUserCookieConsent(cookieConsent)} userId={this.state.loggedInUserId} isLoggedIn={this.state.isUserLoggedIn} userLevel={this.state.loggedInUserLevel} loggedInUser={this.state.loggedInUser} updateSelectedUser={(email, userId) => this.updateSelectedUserDetails(email, userId)}  {...props} />}>
                            </Route>

                                {/* <Route path="/webcam" render={props => <UserCam {...props} {...newVideo} signedInGroupId={this.state.signedInGroup ? this.state.signedInGroup._id : undefined} />} /> */}
                                {/* <Route path="/webcam:video" render={props => <UserCam {...props} {...newVideo} signedInGroupId={this.state.signedInGroup ? this.state.signedInGroup._id : undefined} />} /> */}
                                <Route path="/user" render={props => <User userLevel={this.state.loggedInUserLevel}></User>} />
                                {/* <Route path="/admin-dashboard" render={props => <AdminDashboard></AdminDashboard>} /> */}

                                {/* <Route path="/stats-dashboard" render={props => <StatsDashboard></StatsDashboard>} /> */}

                                {/* Privacy Policy and TOS */}
                                <Route path="/fb-tos" render={props => <FBTOS></FBTOS>} />
                                <Route path="/fb-privacy" render={props => <FBPrivacy></FBPrivacy>} />


                                {/* <Route path="/api-action-dashboard" render={props => <APIDashboard></APIDashboard>} /> */}

                                <Route path="/tpLogin" render={props => <ThirdPartyLogin userCookieConsent={this.state.userCookieConsent} updateUserId={(id) => this.updateUserId(id)} updateLoggedInThirdPartyUserId={(userid) => this.updateLoggedInThirdPartyUserId(userid)} updateUserEmail={(email) => this.updateUserEmail(email)} updateUserAccountType={(type) => this.updateUserAccountType(type)} updateUserToken={(token) => this.updateUserToken(token)}
                                    {...props} />}>
                                </Route>
                                <Route path="/tpSignUp" render={props => <ThirdPartySignup updateUserId={(id) => this.updateUserId(id)} thirdPartyUserid={this.state.loggedInThirdPartyUserId} token={this.state.userToken} {...props} />}>
                                </Route>
                                <Route path="/logout" render={props => <Logout  {...props} />}></Route>

                                <Route path="/profile" render={props => <Profile {...props} updateUserId={(id) => this.updateUserId(id)} email={this.state.loggedInUser} userLevel={this.state.loggedInUserLevel} updateUserName={(name) => this.updateUserName(name)} userId={this.state.loggedInUserId} thirdPartyUserid={this.state.loggedInThirdPartyUserId}
                                    onProfileImgChanged={this.onProfileImgChanged} />} ></Route>

                                <Route path="/userProfile" render={props => <UserProfile {...props} signedInGroupId={this.state.signedInGroup ? this.state.signedInGroup._id : undefined} {...{ onProfileImgChanged: this.onProfileImgChanged, userLevel: this.state.loggedInUserLevel, loggedInUser: this.state.loggedInUserId, loggedInUserName: this.state.loggedInUserName, email: this.state.loggedInUser, thirdPartyUserid: this.state.loggedInThirdPartyUserId }} />} />


                                {/* <Route path="/recordSeedVideo" render={props => <RecordNewModelVideo {...props} email={this.state.loggedInUser} userId={this.state.loggedInUserId} thirdPartyUserid={this.state.loggedInThirdPartyUserId} />}></Route> */}

                                <Route path="/wiki" render={props => <Wikipedia {...props} setCookieConsent={(cookieConsent) => this.setUserCookieConsent(cookieConsent)} isLoggedIn={this.state.isUserLoggedIn} loggedInUser={this.state.loggedInUserId} userName={this.state.loggedInUser} userLevel={this.state.loggedInUserLevel} />}></Route>

                            </Switch>
                        </div>

                    </div>
                    {location.pathname == "/" && <div className="stay-in-touch">
                        <div style={{ fontSize: "28px", marginBottom: "25px", marginTop: "25px" }}>
                            Stay in touch
                        </div>
                        <div>
                            <input
                                id="stayInTouchEmail"
                                type="text"
                                name="stayInTouchEmail"
                                className="email-entry-inpt"
                                placeholder="Enter your email"
                                aria-label="enter your email"
                                onChange={this.handleStayInTouchChange}
                            />
                            <button className="sign-up-style" onClick={this.stayInTouchSignup}>Sign Up</button>
                            {this.state.showStayInTouchModal &&
                                <span className="disappear-message">
                                    You've been added to the mailing list!
                                </span>
                            }
                        </div>
                    </div>
                    }
                    <div className="footer-row">
                        <div className="footer">
                            <div className="footer-item" >
                                <a className="footer-link" href="https://support.microsoft.com/contactus">Contact us</a>
                            </div>
                            <div className="footer-item">
                                <a className="footer-link" href="https://privacy.microsoft.com/en-us/privacystatement">Privacy & Cookies</a>
                            </div>
                            <div className="footer-item">
                                <a className="footer-link" href="https://go.microsoft.com/fwlink/?LinkId=2259814">Consumer Health Privacy</a>
                            </div>
                            <div className="footer-item">
                                <a className="footer-link" href="https://www.microsoft.com/en-us/legal/intellectualproperty/copyright/default">Terms of Use</a>
                            </div>
                            <div className="footer-item">
                                <a className="footer-link" href="https://www.microsoft.com/en-us/legal/intellectualproperty/Trademarks/EN-US.aspx">Trademarks</a>
                            </div>
                            <div className="footer-item" >
                                © 2020 Microsoft
                            </div>
                            {/* <div className="footer-item" >
                                <a className="footer-link" href={process.env.PUBLIC_URL + "/fb-tos"}>Facebook Login TOS</a>
                            </div>
                            <div className="footer-item"  >
                                <a className="footer-link" href={process.env.PUBLIC_URL + "/fb-privacy"}>Facebook Login Privacy Policy</a>
                            </div> */}
                        </div>
                    </div>
                    {/* <div id="skip">
                    <a href="#content">Skip to main content</a>
                </div> */}
                </React.Fragment>
            </ErrorBoundary>
        )
    };
}





const mapDispatchToProps = (dispatch) => ({
    updateScore,
    populateStore,
    requestFailedModal,
    dispatch
});


const App = withRouter(connect(
    
    mapDispatchToProps
)(AppContainer));


export default App
